// extracted by mini-css-extract-plugin
export default {"container":"container__vrcPP","module":"module__PaOI6","image":"image__hbLa2","image-MEGA_MENU_VENDORS_1_CONTROL":"image-MEGA_MENU_VENDORS_1_CONTROL__Kz7PP","label":"label__XOrpD"};